export default {
  line: "เปลี่ยนทางเชื่อม",
  language: "เลือกภาษา",
  common: [
    "บริการลูกค้า",
    "ยกเลิกการระงับ",
    "หุ่ยนต์ตอบกลับ",
    "ตอบกลับอัตโนมัติ",
    "เริ่ม",
    "งานที่เหลืออยู่วันนี้",
    "โปรดตั้งค่าจำนวนงานอัตโนมัติ",
    "เวอร์ชั่นพรีเมี่ยมสำหรับสมาชิก,โปรดอัปเกรด",
    "โปรดตั้งค่าจำนวนงานอัตโนมัติ"
  ],
  upload: [
    "กำลังอัปโหลด...",
    "เกิดข้อผิดพลาดของรูปแบบ",
    "การอัปโหลดเรียบร้อย",
    "การอัปโหลดล้มเหลว"
  ],
  appMsg: [
    "เตรียมอัปเดต...",
    "ดาวน์โหลดเสร็จสิ้น，จะติดตั้งแพ็คเกจการอัพเดทหรือไม่",
    "ดาวน์โหลดล้มเหลว",
    "ดาวน์โหลดแล้ว{num}%",
    "กำลังอัปเดต...",
    "การอัปเดตสำเร็จ，กำลังเริ่มต้น",
    "การอัปเดตล้มเหลว",
    "คลิ๊กอีกครั้งเพื่อออกจากแอพ"
  ],
  vanPull: [
    "ไม่มีข้อมูลแล้ว",
    "ไม่มีข้อมูล"
  ],
  login: {
    text: [
      "จดจำรหัสผ่าน",
      "กำลังเข้าสู่ระบบ...",
      "เข้าสู่ระบบทันที",
      "ลืมรหัสผ่าน",
      "เข้าสู่ระบบมือถือ",
       "อีเมลเข้าสู่ระบบ"
    ],
    placeholder: [
      "กรอกหมายเลขโทรศัพท์",
      "กรอกรหัสผ่าน",
      "กรุณากรอกอีเมล์"
    ],
    i18n: [
      "ไม่มีทะเบียน{title}นี้?",
      "ลงทะเบียน"
    ]
  },
  register: {
    text: [
      "ยินดีต้อนรับสู่การลงทะเบียน",
      "กำลังส่งรหัส...",
      "รับรหัส SMS",
      "กำลังลงทะเบียน...",
      "ลงทะเบียนทันที",
      "มีทะเบียนผู้ใช้แล้ว，ดาวน์โหลดทันที",
      "ลงทะเบียนมือถือ",
       "ลงทะเบียนอีเมล",
       "รับรหัสยืนยัน",
       "รหัสยืนยันทาง SMS",
       "รหัสยืนยันอีเมล",
       "ส่งรหัสยืนยันอีกครั้ง"
    ],
    placeholder: [
      "กรุณากรอกหมายเลขโทรศัพท์",
      "กรุณากรอกรหัสยืนยันทางSMS",
      "กรุณาใส่รหัสผ่าน",
      "ยืนยันรหัสผ่าน",
      "กรอกใส่รหัสเชิญ",
      "รหัสผ่านไม่ตรงกัน",
      "กรุณาใส่รหัสยืนยัน"
    ],
    i18n: [
      "เคยลงทะเบียนแล้ว?",
      "เข้าสู่ระบบ"
    ],
    tips: "วิธีการลงทะเบียน"
  },
  footer: [
    "หน้าแรก",
    "วิดีโอ",
    "แชทลับ",
    "บริการลูกค้า",
    "ข้อมูล<br>ของฉัน",
    "รายได้",
    "คราวด์ฟันดิ้ง",
    "ไทม์ไลน์",
    "กิจกรรม"
  ],
  home: {
    broadcast: "ขอแสดงความยินดีกับสมาชิก {member} ที่แนะนำ {grade} เพื่อรับรางวัลส่งเสริมการขาย {currency}{reward}!",
    menu: [
      "VIPโซน",
      "วิธีการใช้วิดีโอ",
      "รางวัลโปรโมชั่น",
      "ร่วมงานกับเรา",
      "ข้อมูลบริษัท",
      "บัญชีประกัน"
    ],
    taskHall: {
      title: [
        "วิดีโอ",
        "โพสต์สำหรับผู้ค้า"
      ]
    },
    memberList: {
      title: "รายชื่อสมาชิก",
      data: [
        "ขอแสดงความยินดี {member}",
        "วิดีโอที่ดูวันนี้{num}ครั้ง,ได้รับ{currency}{profit}!"
      ]
    },
    businessList: {
      title: "รายชื่อธุรกิจ",
      data: [
        "{member}",
        "จำนวนโพสต์วันนี้{num}ครั้ง"
      ]
    },
    noticeTitle: "ประกาศล่าสุด",
    msg: "งานที่ยังไม่เปิด",
    video: "ยังไม่มีวิธีการสอน",
    title: ["ข้อมูลบริษัท","ระดับสมาชิก"]
  },
  postTask: {
    navBar: {
      title: "โพสต์งาน",
      right: "กฎระเบียบการโพสต์"
    },
    field: [{
        label: "ประเภทงาน",
      },
      {
        label: "ชื่องาน",
        placeholder: "กรุณากรอกชื่องาน",
        error: "เกิดข้อผิดพลาด ต้องกรอกชื่องาน"
      },
      {
        label: "แนะนำงาน",
        placeholder: "กรุณากรอกคำอธิบายของงาน"
      },
      {
        label: "ราคาต่องาน",
        placeholder: "กรุณาใส่ราคาต่อหน่วย",
        error: "เกิดข้อผิดพลาด ต้องกรอกราคาต่อหน่วย"
      },
      {
        label: "จำนวนที่ได้รับ",
        placeholder: "กรุณาใส่จำนวนที่รับ",
        error: "เกิดข้อผิดพลาด ต้องกรอกจำนวน"
      },
      {
        label: "จำนวนที่รับต่อครั้ง",
        placeholder: "กรุณาใส่จำนวนที่รับต่อครั้ง",
        right: "ครั้ง/คน",
        error: "ต้องกรอกจำนวนที่รับต่อครั้ง"
      },
      {
        label: "ราคางานทั้งหมด",
        error: "ราคางานทั้งหมดยังไม่คำนวณ"
      },
      {
        label: "ลิงค์ข้อมูล",
        placeholder: "โปรดกรอกลิงค์ที่อยู่",
        error: "ลิงค์ข้อมูลเว้นว่างไม่ได้"
      },
      {
        label: "ระดับของงาน",
      },
      {
        label: "วันสิ้นสุดงาน",
        placeholder: "คลิกเพื่อเลือกวันที่",
        error: "วันที่ไม่สามารถเว้นว่างได้"
      },
      {
        label: "เงื่อนไขเมื่อเสร็จสิ้น",
        error: "โปรดกรอกเงื่อนไข"
      },
      {
        label: "คำขออัปโหลด",
        placeholder: "กรุณากรอกคำขออัปโหลด",
      },
      {
        label: "ตัวอย่างการตรวจสอบ",
      },
      {
        label: "ขั้นตอนการดำเนินการ",
        placeholder: "ทำตามขั้นตอนง่ายๆช่วยให้เสร็จสมบูรณ์!",
        error: "ขั้นตอนการดำเนินการไม่สามารถเว้นว่างได้",
        img: "มีแผนภาพขั้นตอนที่ไม่สมบูรณ์"
      },
    ],
    button: "การส่ง",
    step: {
      title: "ขั้นตอนการดำเนินการ",
      left: "ยกเลิก",
      right: "เสร็จสิ้น",
      placeholder: "โปรดป้อนคำอธิบายขั้นตอน",
      button: [
        "ลบ",
        "เพิ่ม"
      ]
    },
    tips: [
      "ค่าธรรมเนียมแพลตฟอร์ม {pump}{br} จะต้องทำการจ่ายเงินจำนวน {price}，โปรดตรวจสอบให้แน่ใจว่ายอดเงินในบัญชีเพียงพอ {a}{br}คำเตือน: แพลตฟอร์มนี้ห้ามการเผยแพร่เนื้อหาลามกอนาจาร การพนัน ยาเสพติด และการเมืองซึ่งห้ามโดยกฎหมายทั้งหมด เช่น การหักคะแนนและการปิดบัญชี",
      "จ่ายเงิน",
      "อย่างน้อย1ขั้นตอน",
      "เพิ่มได้สูงสุด10ขั้นตอน"
    ]
  },
  vip: {
    user: {
      title: [
        "ระดับปัจจุบัน",
        "ลูกค้า"
      ],
      label: "งานประจำวัน",
      value: [
        "วันที่มีผล",
        "มีผลถาวร",
        "โปรดลงทะเบียน",
        "วัน",
        "วันที่หมดอายุ"
      ],
    },
    list: {
      label: "งานประจำวัน<b>{number}</b>ครั้ง",
      button: [
        "เปิดใช้งานทันที",
        "ต่อเงินต่อนี้"
      ],
      text: [
        "รายได้ต่อวัน",
        "รายได้ต่อเดือน",
        "รางวัล:ต่อคน",
        "ฟรี",
        "ต่อการสั่งซื้อ"
      ]
    },
    dialog: [
      "ยืนยันค่าใช้จ่าย {currency} {amount} ของ{name}ใช่ไหม?",
      "คุณกำลัง{currname}，ไม่สามารถ{name}",
      "ยืนยันค่าใช้จ่าย {currency} {amount} ของ{name}ใช่ไหม?"
    ],
    more: "ดูข้อมูลเพิ่มเติม",
    top: [
      "จำเป็นสำหรับการอัพเกรด",
      "ส่วนลดการซื้อ",
      ["ระดับ 1", "ระดับ 2", "ระดับ 3"],
      ["ราคา","รายละเอียด"],
      "หมดอายุ"
    ]
  },
  user: {
    title: [
      "งานของฉัน",
      "บันทึกส่วนตัว"
    ],
    default: [
      "ข้อมูลของฉัน",
      "เข้าสู่ระบบ",
      "รหัสการเชิญ",
      "ออกจากระบบ",
      "ความสมดุล",
      "ทอง",
      "กระเป๋าตังค์ของฉัน",
      "เลข",
      "การจำกัด",
      "ดี",
      "ยอดเยี่ยม",
      "ผู้ที่เชิญฉัน"
    ],
    grid: [
      "ยอดเงิน",
      "รายได้เมื่อวาน",
      "รายได้วันนี้",
      "รายได้สัปดาห์นี้",
      "รายได้เดือนนี้",
      "รายได้สัปดาห์ที่แล้ว",
      "รวมรายได้",
      "การเข้าชมวันนี้(ครั้ง)",
      "งานที่เหลือวันนี้(หน่วย)",
      "ค่าคอมมิชชั่นวันนี้",
      "ส่วนลดวันนี้",
      ["วันนี้","เมื่อวาน","สัปดาห์","เดือน"],
      ["ดูยอดเงิน","รายได้จากโปรโมชั่น","การระดมทุนหารายได้"],
      ["ผู้ใช้ที่ลงทะเบียนสัปดาห์นี้","ผู้ใช้ที่ยืนยันสัปดาห์นี้","รายได้ Promoter"],
      ["วันนี้","เมื่อวาน","สามวัน"]
    ],
    menu: [
      "ดูประวัติ",
      "ตรวจสอบงาน",
      "การจัดการโพสต์",
      "ข้อมูลส่วนบุคคล",
      "การผูกบัญชี",
      "การสรุปรายวัน",
      "ประวัติการเปลี่ยนแปลงข้อมูล",
      "เชิญเพื่อนๆ",
      "ทีมของฉัน",
      "คู่มือช่วยเหลือ",
      "ความเชื่อถือ",
      "ดาวน์โหลด APP"
    ]
  },
  userInfo: {
    default: [
      "ข้อมูลส่วนบุคคล",
      "รูปโปรไฟล์",
      "เบอร์มือถือ",
      "เลขที่บัญชี",
      "Alipay",
      "ตรวจสอบแล้ว",
      "รหัสเข้าใช้",
      "รหัสผ่านธุรกรรม",
      "คลิกที่การตั้งค่า",
      "แก้ไขรูปโปรไฟล์",
      "แก้ไขรหัสผ่านเข้าใช้",
      "แก้ไขรหัสธุรกรรม",
      "ส่ง",
      "ล้างแคช",
      "กระเป๋าตังค์USDT",
      "สวิตช์กด",
      "ที่อยู่ของฉัน"
    ],
    label: [
      "รหัสผ่านเดิม",
      "รหัสผ่านใหม่",
      "ยืนยันรหัสผ่าน",
      "รหัสผ่านธุรกรรม",
      "รหัสผ่านธุรกรรมใหม่",
      "ยืนยันรหัสผ่าน",
      "ลืมรหัสผ่านการทำธุรกรรม",
      "รหัส SMS",
      "รหัสยืนยัน"
    ],
    placeholder: [
      "กรุณากรอกรหัสผ่านเดิม",
      "กรุณากรอกรหัสผ่านใหม่",
      "โปรดยืนยันรหัสผ่าน",
      "กรุณากรอกรหัสผ่านกองทุน",
      "กรุณากรอกรหัสผ่านกองทุนใหม่",
      "โปรดยืนยันการกรอกรหัสผ่านกองทุนใหม่"
    ]
  },
  userSet: {
    default: [
      "ตรวจสอบแล้ว",
      "รายละเอียด",
      "ผูก Alipay ",
      "ส่ง",
      "ผูก USDT"
    ],
    label: [
      "ชื่อจริง",
      "เลข QQ",
      "เลข Alipay",
      "ชื่อ Alipay",
      "ประเภทกระเป๋าตังค์",
      "ที่อยู่กระเป๋าตังค์",
      "รายละเอียดที่อยู่",
      "ชื่อ",
      "เบอร์มือถือ"
    ],
    placeholder: [
      "กรุณากรอกชื่อจริงของคุณ (ชื่อของฉันใช้สำหรับถอนเงิน)",
      "กรุณากรอก เลขQQ",
      "กรุณากรอกเลข Alipay",
      "กรุณากรอกชื่อ Alipay",
      "กรุณาเลือกประเภทกระเป๋าตังค์",
      "กรุณากรอกที่อยู่กระเป๋าตังค์",
      "กรุณากรอกรายละเอียดที่อยู่",
      "กรุณาตรวจสอบชื่อจริงของคุณก่อน",
      "กรุณาผูกโทรศัพท์ของคุณก่อน"
    ],
    tips: "คำเตือน: ไม่สามารถแก้ไขบัตรธนาคารที่ถูกผูกไว้ได้ เพื่อใช้สำหรับถอนเงิน"
  },
  bindAccount: {
    default: [
      "ผูกบัญชี",
      "ดูวิดีโอการสอน",
      "ส่ง"
    ],
    tabs: [
      "เลขบัญชี",
      "เลขบัญชี",
      "เลขบัญชี"
    ],
    label: [
      "คำแนะนำ",
      "เพิ่มภาพ",
      "เลขที่บัญชี"
    ],
    placeholder: "โปรดกรอก{account}เลขที่บัญชี"
  },
  bankCard: {
    default: [
      "ผูกบัตรธนาคาร",
      "ตรวจสอบการยืนยัน",
      "กำลังส่ง...",
      "เพิ่มทันที",
      "เพิ่ม"
    ],
    tips: [
      "โปรดเพิ่มบัตรธนาคารหลังการตรวจสอบชื่อจริง",
      "บัญชีธนาคารที่ท่านทำการผูก ชื่อบัญชีจะต้องตรงกันกับชื่อที่ทำการยืนยันตัวตน"
    ],
    label: [
      "ชื่อ",
      "ชื่อธนาคาร",
      "เลขที่บัญชี",
      "รหัส IFSC"
    ],
    placeholder: [
      "กรุณาเลือกชื่อธนาคาร",
      "กรุณากรอกบัญชีธนาคาร",
      "กรุณากรอก รหัสIFSC"
    ]
  },
  wallet: {
    default: [
      "กระเป๋าตังค์ของฉัน",
      "จ่ายเงิน",
      "การถอน",
      "ประวัติการจ่ายเงิน",
      "ประวัติการถอน",
      "เติม",
      "ถอน",
      "Alipay"
    ],
    label: [
      "วิธีการถอนเงิน",
      "จำนวนเงิน",
      "รหัสผ่าน",
      "ส่ง",
      "เบอร์โทร",
      "E-mail",
      "IFSC"
    ],
    placeholder: [
      "เลือกวิธีการถอนเงิน",
      "กรุณากรอกจำนวนเงินที่ถอน",
      "กรุณากรอกรหัสผ่านกองทุน",
      "กรุณาเลือกวิธีการถอนเงิน",
      "กรุณากรอกเบอร์มือถือของผู้รับ",
      "กรุณากรอกอีเมล์",
      "กรุณาระบุ IFSC"
    ],
    msg: [
      "คุณยังไม่ได้ตั้งค่ารหัสธุรกรรม กรุณาตั้งค่าก่อนทำการถอนเงิน",
      "คุณยังไม่ได้ผูกบัตรเครดิต กรุณาผูกมัดก่อน"
    ]
  },
  recharge: {
    default: [
      "การเติมเงิน",
      "รายละเอียดการเติมเงิน",
      "ประวัติการเติมเงิน",
      "ยอดเงินคงเหลือ{money}，โปรดเลือกวิธีการเติมเงิน",
      "จำนวนเงินขั้นต่ำสำหรับธุรกรรม{currency}{min}，สูงสุด{currency}{max}，ค่าธรรมเนียม{fee}%",
      "กำลังส่ง...",
      "เติมเงินทันที",
      "ย้อนกลับ",
      "กำลังโหลด..."
    ],
    label: [
      "ยอดเติมเงิน",
      "ช่องทางการเติมเงิน",
      "ชื่อผู้โอน",
      "ชื่อผู้ชำระ",
      "เบอร์ผู้ชำระ",
      "ผู้ชำระ บัญชีUPI",
      "อีเมล์ผู้ชำระ"
    ],
    placeholder: [
      "กรุณากรอกจำนวนเงินที่เติม",
      "กรุณาเลือกช่องทางการเติมเงิน",
      "กรุณากรอกชื่อผู้โอน",
      "จำนวนเงินขั้นต่ำสำหรับธุรกรรม{currency}{min}",
      "จำนวนเงินสูงสุดสำหรับธุรกรรม{currency}{max}",
      "กรุณากรอกชื่อผู้ชำระเงิน",
      "กรุณากรอกหมายเลขโทรศัพท์มือถือของผู้ชำระเงิน，รหัสพื้นที่ระหว่างประเทศก่อนหมายเลข，เช่น+86",
      "กรุณาระบุผู้ชำระเงิน รหัสUPI",
      "กรุณากรอกอีเมล์ผู้ชำระเงิน"
    ],
    info: [
      "จำนวนที่เติมเงิน",
      "เลขที่ใบสั่งซื้อ",
      "ธนาคารผู้รับ",
      "บัญชีผู้รับ",
      "ชื่อผู้รับ",
      "คัดลอก",
      "{type} โอน",
      "สลิปการโอน",
      "ส่ง",
      "เลขที่ IFSC",
      "UPI",
      "คำแนะนำในการจัดการ",
      "ที่อยู่กระเป๋าตังค์",
      "QR code ใบเสร็จรับเงิน",
    ],
    tips: [
      "เมื่อทำการโอนเสร็จเรียบร้อยแล้ว โปรดอัปโหลดสลิปการโอนเพื่อเป็นหลักฐานยืนยัน",
      "กรุณาสแกน QR Code เพื่อโอนยอดเติมเงิน",
      "โปรดปฏิบัติตามข้อมูลด้านล่างเพื่อทำการโอนให้เสร็จสิ้น",
      "คำเตือน: หลังจากชำระเงินสำเร็จแล้ว โปรดติดต่อฝ่ายบริการลูกค้าออนไลน์และแจ้งหมายเลขบัญชีสมาชิก จำนวนเงินที่เติมเงิน หมายเลขคำสั่งซื้อ หมายเลขบัญชีผู้ฝากเงิน และเวลาเติมเงิน การเงินจะสะดวกสำหรับการเติมเงินให้กับคุณ",
      "หมายเหตุ : สมาชิกต้องส่ง 1 ครั้ง สำหรับการโอนเงินแต่ละครั้ง",
      "หลังจากโอนแล้ว โปรดอัปโหลดภาพหน้าจอของการโอนเพื่อเป็นหลักฐานยืนยัน",
      "กรุณาเลือกวิธีการด้านล่างเพื่อโอนเงินที่ตรงกัน",
      "โปรดอัปโหลดภาพสลิปการโอน",
      "อัตราแลกเปลี่ยน:{price}×{rate}={currency}<b>{money}</b>,(1USDT={currency}{rate})"
    ]
  },
  task: {
    default: [
      "ดูประวัติ",
      "ข้อกำหนดของภารกิจ",
      "การสร้าง",
      "ตรวจสอบ",
      "เปิดลิงค์",
      "คัดลอกลิงค์",
      "ราคาต่อหน่วย",
      "ส่ง",
      "ยอมแพ้",
      "เวลาในการชม"
    ],
    tabs: [
      "กำลังดำเนินการ",
      "กำลังตรวจสอบ",
      "เสร็จสิ้น",
      "เกิดความล้มเหลว",
      "โจมตี",
      "ยอมแพ้แล้ว"
    ],
    msg: "กรุณาอัพโหลดรูปภาพของงานที่เสร็จสมบูรณ์",
    info: [
      "รายละเอียดงาน",
      "หัวข้องาน",
      "รายรับของงาน",
      "ข้อมูงาน",
      "คำขออัปโหลด",
      "ส่งตัวอย่าง",
      "ผู้ใช้ยังไม่ได้ส่งตัวอย่าง",
      "ตรวจสอบรายละเอียด",
      "วันที่ตรวจสอบ",
      "ความต้องการ",
      "โพสต์",
      "คัดลอก",
      "การกระโดด",
      "ขั้นตอนการดำเนินงาน",
      "ขั้นตอนที่{index}",
      "ตัวอย่างการตรวจสอบ",
      "ตัวอย่างที่ไม่ผ่านการตรวจสอบ",
      "กำลังโหลด...",
      "การละทิ้งงาน",
      "เริ่มรับชม",
      "การโพสต์เนื้อหา"
    ],
    index: [
      "สถานะ",
      "ระดับปัจจุบันของคุณคือ <i style=\"color:#1989fa\">{currVip}</i><br>โดยสามารถรับเฉพาะ<i style=\"color:#1989fa\">{currVip}</i>ระดับของงาน<br>ไม่ว่าจะเข้าร่วม <i style=\"color:#dd6161\">{vip}</i> ระดับ",
      "เข้าร่วมเดี๋ยวนี้",
      "กรุณาเลือกหมวดหมู่งาน"
    ],
    list: [
      "รายงาน",
      "อุปสงค์",
      "คงเหลือ",
      "ข้อจำกัด",
      "การรับ"
    ],
    show: [
      "รายละเอียดภารกิจ",
      "คนได้รับ",
      "คงเหลือ{num}",
      "ตรวจสอบภายใน48ชั่วโมง",
      "รายละเอียดภารกิจ",
      "ด้านอุปสงค์",
      "มาตรฐานการตรวจสอบ",
      "คัดลอก",
      "การกระโดด",
      "ขั้นตอนงาน",
      "ขั้นตอนที่{index}",
      "ตัวอย่างการตรวจสอบ",
      "ตัวอย่างที่ไม่ผ่านการตรวจสอบ",
      "กำลังโหลด...",
      "กำลังส่ง...",
      "การรับงาน",
      "เข้าสู่ระบบทันที",
      "การโพสต์เนื้อหา"
    ]
  },
  audit: {
    default: [
      "การตรวจสอบงาน",
      "วันที่",
      "วันที่อัปเดต",
      "การตรวจสอบ",
       "ตรวจสอบ",
    ],
    tabs: [
      "กำลังดำเนินการ",
      "กำลังตรวจสอบ",
      "เสร็จสิ้นแล้ว",
      "เกิดความล้มเหลว"
    ],
   info: [
      "ตรวจสอบรายละเอียด",
      "รับผิดชอบหัวข้อ",
      "รับผิดชอบจำนวนเงิน",
      "สำเร็จแล้ว",
      "เหลืออีก {num} โควต้า",
      "รายละเอียดภารกิจ",
      "ข้อมูลลิงค์",
      "ตัวอย่างการตรวจสอบ",
      "ผู้ใช้ที่ได้รับ",
      "รับ",
      "สำเร็จแล้ว",
      "ส่งตัวอย่าง",
      "ผู้ใช้ไม่ได้ส่งตัวอย่าง",
      "อัปเดตวัน",
      "กำลังโหลด...",
      "เจตนาร้าย",
      "ลองใหม่",
      "ล้มเหลว",
      "สำเร็จ",
      "ตรวจสอบงาน",
      "คำแนะนำในการตรวจสอบ",
      "กรุณาป้อนคำอธิบายตรวจสอบ",
      "ภาระกิจที่ส่งไม่ได้มาตรฐานและจำเป็นต้องส่งใหม่เพื่อตรวจสอบ",
      "ยินดีด้วยที่ภาระกิจเสร็จสิ้น ทำดีต่อไป",
      "ภาพหน้าจอของภาระกิจที่ส่งไม่ถูกต้อง แคปภาพล้มเหลว",
      "ภาระกิจที่ส่งเป็นอันตราย ภาระกิจล้มเหลว"
    ]
  },
  postRecord: [
    "การจัดการการโพสต์",
    "การโพสต์",
    "ยอดรวม",
    "เสร็จสิ้นแล้ว",
    "วันสิ้นสุด",
    "ตรวจสอบ",
    "การถอน",
    "แก้ไข"
  ],
  dayReport: [
    "งบรายวัน",
    "รายได้รวม",
    "งานที่ฉันทำเสร็จแล้ว",
    "รายได้จากภารกิจของฉัน",
    "งานที่ผู้ร่วมทีมเสร็จสิ้น",
    "รายได้จากภารกิจของทีม",
     "ครั้ง",
     "30 วันที่ผ่านมา",
     "จำนวน",
     "งาน",
     "ลูกทีม",
     "การใช้จ่าย",
     "วันที่"
   ],
   fundRecord: {
     default: [
       "บันทึกค่าใช้จ่าย",
       "บันทึกการเติมเงิน",
       "บันทึกรายได้",
       "ค่าใช้จ่าย",
       "รับ",
       "สาขา"
     ],
     tabs: [
       "รายได้",
       "รายจ่าย",
       "การชำระ"
     ]
   },
   promote: [
     ["ทุกการเชิญครบ {num}", "คน รับทันที ", ""],
     "ถอนได้ด้วยตรง",
     "แต่ละคนได้รับเชิญ {num} ผู้ใช้ที่ถูกต้อง",
     ["รางวัลรายวัน", "ใครๆ ก็รับได้ทุกวัน"],
     ["ผู้ใช้ที่ถูกต้อง","เชิญผู้ใช้ที่มีตัวตน {num} ราย ทุกวัน"],
     ["เชิญ","รับ","เชิญเลย"],
     "รางวัลพนักงานทีม",
     ["ตัวแทน","โบนัส","เงินเดือน"],
     ["บุคคล","คำขอ","เชิญ"],
     "แนะนำคณะกรรมการ",
     ["แชร์","รับทันที"],
     ["แชร์ไปยังแพลตฟอร์มโซเชียล","แชร์"],
     ["จ่ายเงิน","เติมเงินด้วยตัวเอง","จ่ายเงิน"],
     ["คนขุดแร่","ซื้อนักขุด","ซื้อ"],
     ["การจัดการทางการเงิน","การจัดการการลงทุนและการเงิน","การลงทุน"],
     ["แชร์กับเพื่อนทันที","รหัสเชิญ"],
     ["คัดลอกลิงก์","คัดลอกรหัสเชิญ","รหัส QR","แบ่งปันโปสเตอร์"],
     "บันทึกภาพ",
     "ค่าคอมมิชชั่นจากการอัปเกรด VIP",
     "รายละเอียด"
   ],
   teamReport: {
     default: [
       "ค้นหา",
       "ยอดทีม",
       "รายได้ของทีม",
       "ยอดเติมเงินรวมของทีม",
       "ยอดถอนเงินรวมของทีม",
       "ยอดชำระ VIP รวมของทีม",
       "เพื่อนที่คุณแนะนำโดยตรง",
       "จำนวนคนในทีม",
       "สมาชิกที่เข้ามาใหม่",
       "คน",
       "ฉัน",
       "ผู้ใช้",
       "จ่ายเงิน",
       "ถอน",
       "ส่วนลด",
       "วิดีโอ",
       "เลือกปีเดือนวัน",
       "ไม่มีข้อมูล",
       "ยอดการเติมเงิน",
       "ยอดคนที่เติมเงิน",
       "ยอดโบนัสชวนเพื่อน",
       "จำนวน VIP ทั้งหมด",
       "สมาชิกที่ใช้งาน"
     ],
     tabs: [
       "การรายงานของทีม",
       "ทีมของฉัน"
     ],
     team: [
       "ขั้นที่ 1",
       "ขั้นที่ 2",
       "ขั้นที่ 3"
     ]
   },
   help: [
     "คู่มือช่วยเหลือ",
     "ยังไม่มีเนื้อหา"
   ],
   credit: [
     "ศูนย์สินเชื่อ",
     "ใบแจ้งยอดสินเชื่อ",
     "ประวัติเครดิต",
     "<p>1. คะแนนเครดิตมีการประเมินสัปดาห์ละครั้ง</p><p>2. คะแนนเครดิตผู้ใช้เริ่มต้น: <b>60</b></p><p>3. หากตรวจพบ ที่ผู้ใช้ดำเนินการอัปโหลดภาพเท็จจะถูกหักเป็นเวลาหนึ่งวัน: <b>1</b> คะแนน ขีดจำกัดการหักสูงสุด: <b>7</b> คะแนน</p><p>4. ถ้า ตรวจไม่พบผู้ใช้ใช้ภาพปลอม เพิ่ม <b>1 </b>คะแนน</p><p>5 คะแนนเครดิตต่ำกว่า <b>50</b> คะแนนจะถูกจำกัดไม่ให้ถอน</p> <p>6. คะแนนเครดิตต่ำกว่า <b>30</b> b>จำนวนงานแยกลดลงครึ่งหนึ่ง</p><p>7 คะแนนเครดิตน้อยกว่าหรือเท่ากับ <b>0</b> คะแนน จะถูกแบน</p>",
    "เครดิตของฉัน",
    "ไม่มีประวัติเครดิตในขณะนี้"
  ],
  appDown: [
    "ดาวน์โหลดแอป",
     "สแกนรหัส QR เพื่อดาวน์โหลดแอป",
     "บันทึกรหัส QR",
     "บันทึกรหัส QR สำเร็จ",
     "บันทึกรหัส QR ไม่สำเร็จ โปรดลองหลายครั้งหรือจับภาพหน้าจอเพื่อบันทึก",
     "คัดลอก",
     "ดาวน์โหลด Android",
     "ดาวน์โหลด IOS",
     "หากไม่สามารถดาวน์โหลดเวอร์ชัน IOS ได้ตามปกติ โปรดถอนการติดตั้งเวอร์ชันดั้งเดิมแล้วดาวน์โหลดและติดตั้งอีกครั้ง การถอนการติดตั้งจะไม่ส่งผลต่อการใช้งาน"
  ],
  dialog: [
    "แจ้งเตือน",
    "ยืนยัน",
     "กำลังส่ง...",
     "คัดลอกสำเร็จ",
     "เวอร์ชันระบบ IOS ต่ำและไม่รองรับ",
     "กำลังลงทะเบียน...",
     "กำลังโหลด...",
     "ยังไม่เปิด โปรดคอยติดตาม",
     "บันทึกภาพสำเร็จ",
     "บันทึกภาพไม่สำเร็จ<br>หากไม่สำเร็จ โปรดลองหลายครั้งหรือจับภาพหน้าจอเพื่อบันทึก",
     "เบราว์เซอร์ไม่รองรับ โปรดจับภาพหน้าจอ",
     "อยู่ในระหว่างการหาผู้ร่วมธุรกิจ",
     "ขณะนี้ยังไม่มีแผนการจ่ายเงิน"
  ],
  lineList: [
    "เลือกไลน์",
    "ไลน์ปัจจุบัน",
    "ไลน์"
  ],
  serviceCenter: [
     "บริการลูกค้า",
     "สวัสดี บริการลูกค้าพิเศษ",
     "ยินดีให้บริการ",
     "บริการตนเอง",
     "บริการออนไลน์",
     "เติมเงินบริการลูกค้า",
     "ไลน์บริการลูกค้า",
     "ติดต่อ",
     "คู่มือช่วยเหลือ",
     "ประกาศจากเว็บไซต์"
  ],
  theme: {
     title: "เปลี่ยนธีม",
     black:"ธีมสีดำ",
     white: "ธีมสีขาว",
     green: "ธีมสีเขียว"
  },
  Finance: [
    ["เงินปันผลรายวัน","ส่วนของของขวัญ","ตัวเลือกของขวัญ","เงินอุดหนุนเพิ่มเติม","ครั้ง"],
    "ซื้อเลย",
    "รายละเอียดทางการเงิน",
    "ราคาสั่งซื้อ",
    ["เปอร์เซ็นต์","วัน"],
    "สั่งเลย",
    ["ยอดคงเหลือในบัญชี", "ราคาต่อหน่วย", "เงินปันผลรายวัน", "รอบโครงการ", "วัน", "จำนวนการซื้อ", "จำนวนการซื้อสูงสุด", "รายได้ที่คาดหวัง"],
    "ส่ง",
    "การเงินของฉัน",
    ["ถอนดอกเบี้ย","สิ้นสุด","รายละเอียด"],
    ["คุณแน่ใจหรือไม่ว่าต้องการถอนดอกเบี้ย ดอกเบี้ยจะถูกคำนวณใหม่หลังจากการถอน", "คุณแน่ใจหรือว่าจะหยุดการเงินนี้"],
    "รายละเอียดการสั่งซื้อ",
    ["ยอดรวม","สถานะการสั่งซื้อ","วันที่ซื้อ"]
  ],
  Video: [
    ["ผู้เยี่ยมชม","อัพเกรดเพื่อรับสิทธิประโยชน์มากมาย"],
    "อัพเกรดทันที",
    ["รายได้วันนี้", "ทุกออเดอร์", "การถอนเงินสด"],
    ["จำนวนวิดีโอที่ดูวันนี้","จำนวนวิดีโอที่เหลือ"],
    "เริ่มดู",
    "เข้าสู่ระบบเพื่อดู",
    "ดูแบบเต็มหน้าจอ",
    "ปิด",
    ["แนะนำให้ดาวน์โหลด","ดาวน์โหลดฟรี"],
    "ยอดผู้ใช้ออนไลน์ปัจจุบัน",
    "เสร็จสิ้นทั้งหมด",
    "กรุณาผูกหมายเลขโทรศัพท์ของคุณก่อน",
     "กรุณาผูกที่อยู่อีเมลของคุณก่อน"
  ],
 Disclaimer: [
    ["ฉันได้อ่านและยอมรับ","ข้อจำกัดความรับผิดชอบ"],
    ["ข้อตกลงการเข้าสู่ระบบ","ไม่เห็นด้วย","เห็นด้วย"]
  ],
 Withdraw: [
    "ยอดเงินคงเหลือ {money} โปรดเลือกบัญชีถอนเงิน",
    "บัญชีถอนเงิน",
    "กรุณาเลือกบัญชีถอนเงิน",
    "จำนวนเงินที่ถอน",
    "กรุณากรอกจำนวนเงินที่ถอน",
    "ที่อยู่กระเป๋าสตางค์",
    "กรุณากรอกที่อยู่กระเป๋าเงิน",
    "รหัสผ่านกองทุน",
    "กรุณากรอกรหัสผ่านกองทุน",
    "ถอนตอนนี้",
    "อัตราแลกเปลี่ยน: {price}÷{rate}=<b>{money}</b>USDT,(1USDT={currency}{rate})",
    "เลือกบัญชีถอน",
    ["เพิ่มบัญชีธนาคาร","ผูกกระเป๋าเงิน USDT"],
    "ด้รับจริง ๆ",
    "หมายเลขโทรศัพท์",
    "กรุณากรอกหมายเลขโทรศัพท์",
    "จดหมาย",
    "กรุณากรอกอีเมล์",
    "ยูพีไอ",
    "กรุณาป้อน UPI"
  ],
  Partner: [
    "สถานะของ VIP Group",
     "VIP Group",
     ["สร้าง VIP Group","เข้าร่วม VIP Group","VIP Group ของฉัน"],
     ["สถานะของ VIP Group","กรุณาเลือกระดับ VIP Group"],
     ["จำนวน VIP Group","กรุณาเลือกจำนวนสำเนาของ VIP Group"],
     ["จำนวนการสั่งซื้อ","กรุณากรอกจำนวนเล่มที่จะซื้อ"],
     "ยอดเงินต่อรายการ",
     "สมัคร VIP Group ทันที",
     ["กำลังดำเนินการ","สมบูรณ์"],
     ["ผู้สร้าง VIP Group", "สถานะของ VIP Group", "จำนวน VIP Group", "ยอดเงินต่อรายการ", "สั่งซื้อสำเร็จ", "เสิร์ฟ", "ผนวก", "ค่าคอมมิชชั่น", "เข้าร่วม", "วันที่สั่งซื้อ"],
     "กฎระเบียบของ VIP Group",
     ["ชื่อ VIP Group","กรุณากรอกชื่อ VIP Group"]
  ],
  Share: [
    "โบนัสประจำวัน",
     ["รายการงาน", "ผู้ใช้ที่ลงทะเบียนที่โกงจะถูกแบน", "แชร์"],
     ["ขั้นตอนงาน","อัปโหลด {num} ครั้งทุกวัน"],
     ["ภาพถอนสำเร็จ", "แชร์รูปภาพสำเร็จไปยังกลุ่มอย่างเป็นทางการ", "ผู้ใช้ที่ส่งข้อความหรือภาพสแปมจะถูกแบนผู้ใช้", "หลังจากการอนุมัติ รางวัลจะออกสู่บัญชีของคุณ"],
     ["เลือกรูปที่ต้องการอัปโหลด","กรุณาใส่ที่อยู่ลิงค์ {name} ของคุณ","ตัวอย่างรูปภาพ"],
     "อัปโหลด",
     "แชร์เลย",
     "แบ่งปันรายได้วันนี้",
     "ขั้นตอนการแชร์",
     "ข้อความการแชร์",
     "คัดลอกข้อความ",
     "อัปโหลดรูปหรือลิงก์",
     "ยกเลิก",
     "รับ",
     "รางวัล"
  ],
  Community: [
    "ไทม์ไลน์",
     ["ล่าสุด","ถอนเงิน","ซื้อ","คอมมิชชั่น","รายได้"],
     ["ราคา","รายได้ต่อการดู","วิดีโอต่อวัน"],
     "ฉันต้องการอัปเกรด"
  ],
  Register: [
    "กรุณากรอกอีเมลของคุณ",
     ["โปรดป้อนรหัสยืนยันอีเมล","รับรหัสอีเมล","รหัสยืนยันอีเมล"]
  ],
  UserInfo: [
    ["อีเมล","คลิกเพื่อผูก"],
     ["ผูกโทรศัพท์มือถือ", "ผูกกล่องจดหมาย"],
     ["หมายเลขโทรศัพท์มือถือ","กรุณาป้อนหมายเลขโทรศัพท์มือถือ"],
     ["อีเมล","โปรดป้อนอีเมล"],
     "กรุณาผูกหมายเลขโทรศัพท์มือถือของคุณก่อนที่จะถอน",
     "กรุณาผูกที่อยู่อีเมลของคุณก่อนที่จะถอน",
     ["Telegram การรับรอง","บทช่วยสอน"]
  ],
  Bet: [
    "ระยะทาง {no} จับสลาก",
    "รอจับสลาก",
    "ยอดเงินในบัญชี",
    "ปัญหา",
    "ปัญหา",
    "เนื้อหาเดิมพัน",
    "เดิมพัน",
    "จำนวน",
    "สถานะ",
    "ไม่มีบันทึก",
    "เอาออกไป",
    "เวลา",
    "ปัญหา",
    "หมายเลขที่ชนะ",
    "ซำ",
    "เดิมพัน",
    "ขอแสดงความยินดี <em id='win_name'>{name}</em> สำหรับการเดิมพัน <i id='win_lottery'>{lottery}</i> และรางวัล <em id='win_money'>{currency}{price}</em>",
    "ของฉัน<br>เดิมพัน",
    "หวย<br>บันทึก",
    "เล่น",
    "วิธีการเล่น",
    "ห้องเชื่อมถึงกัน...",
    "รอจับสลาก",
    "ไม่ชนะ",
    "ชนะ {price}",
    "ลบ",
    "ยกเลิก",
    "หยุด",
    "ไปน้ำ",
    "ส่งไม่สำเร็จ คลิกข้อความเพื่อส่งใหม่",
    "ไม่มีห้องเดิมพัน",
    "จะตามไปไหม",
    "ติดตาม",
    "เบราว์เซอร์ของคุณไม่รองรับโปรโตคอล WebSocket",
    "การสื่อสารผ่านแชทล้มเหลว กำลังพยายามเชื่อมต่อใหม่",
    "เคล็ดลับ",
    "วินาที ล้างหน้าจอ",
    "เบราว์เซอร์ของคุณไม่รองรับ",
    "ประเภทการเดิมพัน",
    "คุณยังไม่ได้เข้าสู่ระบบ กรุณาเข้าสู่ระบบก่อน",
    "ส่งได้แต่รูป",
    "ยอดเงินในบัญชีน้อยกว่า {balance} คุณไม่สามารถเข้าห้องได้ กรุณาเติมเงิน",
    "แนวโน้ม",
    "ทางการ<br>เว็บ",
    "กำไร",
    ["เดิมพัน","ผู้ชนะ","เงินคืน","กำไร"],
    ["วันนี้","เมื่อวาน","สัปดาห์","เดือน","ทั้งหมด"]
  ],
  BetView: [
    "อัตราต่อรองสูงสุด",
    "โบนัส",
    "จำนวนเงินด่วน",
    "เดิมพัน",
    "ใส่จำนวนเงิน",
    "ยกเลิก",
    "ไล่ล่า",
    "เดิมพันตอนนี้",
    "กำลังโหลด...",
    "เนื้อหาเดิมพัน",
    "อัตราต่อรอง",
    "กรุณาใส่จำนวนเงินเดิมพัน",
    "ปัญหาปัจจุบันยังไม่เปิด",
    "รอผลเสมอ เดิมพันไม่ได้",
    "ปัญหานี้ถูกปิด โปรดเดิมพันในฉบับต่อไป",
    "กรุณาเลือกเนื้อหาเดิมพัน",
    "ติดตามเดิมพัน",
    "ปัญหา",
    "ปัญหา",
    "วิธีการเล่น",
    "เนื้อหาเดิมพัน",
    "จำนวนเงินเดิมพัน",
    "ติดตาม",
    "ใช้ได้เฉพาะผู้ใช้วีไอพี"
  ],
  Coupon: [
    "ส่วนลด",
    ["ใช้แล้ว", "ใช้แล้ว", "หมดอายุ"],
    ["บัตรกำนัล","ใช้ได้จนถึง","มูลค่า"],
    "โอนย้าย",
     ["เลือกทั้งหมด","โปรดป้อนชื่อผู้ใช้สำหรับการโอน","ยืนยัน","ยกเลิก"]
  ],
  Trend: [
    "แนวโน้ม",
    ["30 ประเด็น", "50 ประเด็น", "100 ประเด็น"],
    ["เทรนด์เลขเดี่ยว","เทรนด์หลายเลข","เทรนด์ขนาด","เทรนด์เดี่ยวและคู่","ค่ารวม|รูปแบบ"],
    ["ร้อย", "สิบ", "หนึ่ง", "สามหลา", "สองตัวแรก", "สองอันหลัง", "สามหลากับค่า"],
    ['ร้อยสิบ,3','ร้อย,2','สิบ,2','หนึ่ง,2'],
    ['ร้อยสิบ,3', 'มูลค่ารวม', 'รูปแบบ,2'],
    ["ใหญ่","เล็ก"],
    ["เลขคู่","เลขคี่"],
    ["ใหญ่","เล็ก","และ","เลขคู่","เลขคี่"],
    "ประเด็น",
    ["จำนวนช่วงเวลา", "จำนวนครั้ง", "ออกต่อเนื่องสูงสุด", "ละเว้นสูงสุด", "ละเว้นโดยเฉลี่ย"]
  ],
  BlindBox: [
    "ประวัติการสุ่ม"
  ],
  Activity: [
    "กิจกรรม",
    ["ทั้งหมด","ตัวแทน","สมาชิก","ความร่วมมือเชิงกลยุทธ์","จบ"],
    "ดูรายละเอียด"
  ]
}